import React from 'react'
import { Status } from 'shared/ui'
import { organizationStatusConfig } from 'entities/Organization/ui/Status/config'
import { type IOrganizationStatus } from 'entities/Organization'

export const OrganizationStatus = ({ status }: { status: IOrganizationStatus }) => (
  <Status {...organizationStatusConfig[status]} />
)
